import { commentsAPI } from '../../api';

const state = () => ({
    loading: true,
    requestId: null,
    comments: [],
});

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setRequestId(state, requestId) {
        state.requestId = requestId;
    },
    setRequestComments(state, comments) {
        state.comments = comments;
    },
    clearCommentsState(state) {
        state.requestId = null;
        state.comments = [];
    },
};

const actions = {
    async getCommentsOfRequest({ commit }, requestId) {
        const response = await commentsAPI.getCommentsOfRequestAPI(requestId);
        commit('setRequestId', requestId);
        commit('setRequestComments', response.data);
        return response.data;
    },
    async addComment(_, { requestId, body }) {
        const response = await commentsAPI.addCommentAPI(requestId, body);
        return response.data;
    },
};

export default {
    state,
    mutations,
    actions,
};
